import React from "react";
import "./styles.scss";
import styled from "styled-components";

import { BsFacebook, BsInstagram } from "react-icons/bs";
import { BiMenuAltRight } from "react-icons/bi";
import { Logo } from "assets/logos";

import { primaryFont } from "utils";

import { routes } from "routes/MainPage";
import { useLocation, useHistory } from "react-router-dom";

const NavbarContainer = styled.div`
  background-color: ${(props) => props.theme.navbar.background};
  color: ${(props) => props.theme.navbar.color};
  span {
    font-family: ${primaryFont};
  }
  .active {
    border-bottom: 2px solid ${(props) => props.theme.borderText};
  }
  .nav__bar__items_right .nav__bar__items span,
  .nav__bar__wrapper span {
    &:hover {
      color: ${(props) => props.theme.navbar.hover.color};
      cursor: pointer;
    }
  }
  .nav__bar__brand__logo span {
    color: ${(props) => props.theme.navbar.color};

    &:hover {
      color: ${(props) => props.theme.navbar.hover.color};
      cursor: pointer;
    }
  }
`;
const NavbarMobileContainer = styled.div`
  background-color: ${(props) => props.theme.navbar.background};
  color: ${(props) => props.theme.navbar.color};
  .nav__bar__brand__logo span {
    transition: all 0.3s ease-in-out;
    font-family: ${primaryFont};
    &:hover {
      color: ${(props) => props.theme.navbar.hover.color};
      cursor: pointer;
    }
  }
  .nav__bar__mobile__items {
    .active {
      background-color: ${(props) =>
        props.theme.navbar.mobile.hover.background};
    }
    span {
      font-family: ${primaryFont};
      &:hover {
        background-color: ${(props) =>
          props.theme.navbar.mobile.hover.background};
        cursor: pointer;
      }
    }
    border-bottom: 1px solid ${(props) => props.theme.navbar.hover.background};
  }
`;
export const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const [isNotTop, setIsNotTop] = React.useState(false);
  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const refNavbarMobile = React.useRef(null);
  const refMenuToggle = React.useRef(null);

  const history = useHistory();
  const location = useLocation();
  const { pathname } = useLocation();

  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        refNavbarMobile.current &&
        !refNavbarMobile.current.contains(event.target) &&
        event.target.class !== "menuWrapper" &&
        event.target.id != "menuToggleContainer" &&
        event.target.tagName !== "svg" &&
        event.target.tagName !== "path"
      ) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside, false);

    const closeNavbar = () => {
      if (window.innerWidth > 768) {
        if (isOpen) {
          setIsOpen(false);
        }
      }
    };
    window.addEventListener("resize", closeNavbar);

    const controlScroll = () => {
      if (window.scrollY > 0) {
        if (!isNotTop && !isOpen) {
          setIsNotTop(true);
        }
        // if the scroll is at the top, set isNotTop to false
        else if (window.scrollY == 1 && isNotTop) {
          setIsNotTop(false);
        }
      }
    };
    window.addEventListener("scroll", controlScroll);
    return () => {
      window.removeEventListener("resize", closeNavbar);
      window.removeEventListener("scroll", controlScroll);
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, [isOpen, isNotTop]);

  return (
    <>
      <NavbarContainer
        className={`nav__bar ${
          isNotTop
            ? "scrolled"
            : pathname.includes("/cotizar") || pathname.includes("/tarifas") || pathname.includes("/privacidad")
            ? "scrolled"
            : "not__scrolled"
        }`}
      >
        <div className="nav__bar__brand">
          <div className="nav__bar__brand__logo">
            <img
              src={Logo}
              alt="logo"
              hidden={isOpen}
              onClick={() => history.push("/")}
            />
          </div>
        </div>
        <div className="nav__bar__items_left">
          <div className="nav__bar__items">
            {routes
              .filter((route) => route.navbar)
              .map((route) => (
                <span
                  className={`nav__bar__items__item ${
                    route.pathWithoutParams == location.pathname ? "active" : ""
                  }`}
                  onClick={() => history.push(route.pathWithoutParams)}
                  key={route.label}
                >
                  {route.label}
                </span>
              ))}
            <div className="nav__bar__items__item dropdown__container">
              <span
                className="dropdown__title"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                Paquetes
              </span>
              <ul hidden={!dropdownOpen} className="dropdown__list">
                <li
                  onClick={() => {
                    history.push("/vuelos/national");
                    setDropdownOpen(false);
                  }}
                >
                  Paquetes Nacionales
                </li>
                <li
                  onClick={() => {
                    history.push("/vuelos/international");
                    setDropdownOpen(false);
                  }}
                >
                  Paquetes Internacionales
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="nav__bar__items_right">
          <div className="nav__bar__items">
            <span
              onClick={() => {
                window.open("https://www.facebook.com/odessaturismo", "_blank");
                setIsOpen(false);
              }}
            >
              <BsFacebook />
            </span>
            <span
              onClick={() => {
                window.open(
                  "https://www.instagram.com/odessaturismo/",
                  "_blank"
                );
                setIsOpen(false);
              }}
            >
              <BsInstagram />
            </span>
          </div>
        </div>
        <div className="nav__bar__wrapper">
          <span
            className="menuWrapper"
            onClick={() => {
              setIsOpen(!isOpen);
            }}
            ref={refMenuToggle}
            id="menuToggleContainer"
          >
            <BiMenuAltRight className="menuWrapper" />
          </span>
        </div>
      </NavbarContainer>

      <NavbarMobileContainer
        className={`nav__bar__mobile ${isOpen ? "open__navbar" : ""}`}
        ref={refNavbarMobile}
      >
        <div className="nav__bar__mobile__content">
          <div className="nav__bar__brand__logo">
            <img
              src={Logo}
              alt="logo"
              onClick={() => {
                history.push("/");
                setIsOpen(!isOpen);
              }}
            />
            <span
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            >
              <BiMenuAltRight />
            </span>
          </div>
          <div className="nav__bar__mobile__items">
            {routes
              .filter((route) => route.navbar)
              .map((route) => (
                <span
                  className={`nav__bar__items__item ${
                    route.pathWithoutParams == location.pathname ? "active" : ""
                  }`}
                  onClick={() => {
                    history.push(route.pathWithoutParams);
                    setIsOpen(false);
                  }}
                  key={route.label}
                >
                  {route.label}
                </span>
              ))}
            <div
              className="nav__bar__items__item dropdown__container"
              onClick={() => setDropdownOpen(!dropdownOpen)}
            >
              <span className="dropdown__title">Paquetes</span>
              <ul hidden={!dropdownOpen} className="dropdown__list">
                <li
                  onClick={() => {
                    history.push("/vuelos/national");
                    setDropdownOpen(false);
                  }}
                >
                  Paquetes Nacionales
                </li>
                <li
                  onClick={() => {
                    history.push("/vuelos/international");
                    setDropdownOpen(false);
                  }}
                >
                  Paquetes Internacionales
                </li>
              </ul>
            </div>
          </div>
          <div className="nav__bar__mobile__items">
            <span
              onClick={() => {
                window.open("https://www.facebook.com/odessaturismo", "_blank");
                setIsOpen(false);
              }}
            >
              <BsFacebook /> Facebook
            </span>
            <span
              onClick={() => {
                window.open(
                  "https://www.instagram.com/odessaturismo/",
                  "_blank"
                );
                setIsOpen(false);
              }}
            >
              <BsInstagram /> Instagram
            </span>
          </div>
        </div>
      </NavbarMobileContainer>
    </>
  );
};
